<template>
  <multiselect-tags
    v-model="value[filterKey]"
    :object="false"
    v-bind="options"
  />
</template>

<script lang="ts" setup>
import type { Variant } from '@components/utils/inputs/Field.vue';
import MultiselectTags from '@components/utils/MultiselectTags.vue';
import { useVModel } from '@vueuse/core';

export interface Option {
  labelProp?: string;
  variant?: Variant;
  label: string;
  value: string;
}

export type OptionsQueryFn = (query: string) => Promise<Option[]>;

export interface Options {
  options: Option[] | OptionsQueryFn;
  label: string;
  placeholder: string;
}

export interface Props<Value = unknown[]> {
  modelValue: Record<string, Value>;
  filterKey: string;
  options: Options;
}

const emit = defineEmits(['update:modelValue']);
const props = defineProps<Props>();
const value = useVModel(props, 'modelValue', emit, { passive: true });
</script>

<style lang="scss" scoped></style>
